import { ApolloClient, InMemoryCache } from '@apollo/client';

import introspectionResult from './introspectionResult';
import Link from './link';

export const cache = new InMemoryCache({
  addTypename: true,
  possibleTypes: introspectionResult.possibleTypes,
  typePolicies: {
    LifeApplication: {
      fields: {
        policies: {
          /**
           * The `policies` field on the LifeApplication does not have any identifying fields, so
           * the cache doesn't know how to handle updates to it. By setting merge: true, we are telling
           * the cache to always just merge existing and incoming `policies` values.
           */
          merge: true,
        },
      },
    },
    LifeInsuranceCarrierType: {
      /**
       * The carrier type generates a random id, so the normalized cache will store every policy's
       * carrier as its own value in the cache. Since carriers are not specific to policies, we can
       * simplify our cache by providing a custom `keyFields` to use the slug as the identifying
       * field for the cache. Now, instead of X carriers in the cache for X policies, we only have
       * one in the cache for each slug.
       */
      keyFields: ['slug'],
    },
    CarrierReview: {
      keyFields: ['slug'],
    },
  },
});

const apolloClient = new ApolloClient({ link: Link, cache });

export default apolloClient;
